import { motion } from 'framer-motion';

export function GlassCard({ children, className = '', ...props }: any) {
    return (
        <motion.div
            className={`glass-card p-6 rounded-2xl border border-white/10 ${className}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            {...props}
        >
            {children}
        </motion.div>
    );
}
